import React from "react"

function SubjectSearchIcon(props) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M14.6693 7.99967C14.6693 11.6817 11.6846 14.6663 8.0026 14.6663C4.3206 14.6663 1.33594 11.6817 1.33594 7.99967C1.33594 4.31767 4.3206 1.33301 8.0026 1.33301C11.6846 1.33301 14.6693 4.31767 14.6693 7.99967ZM5.9826 5.97967C6.07635 5.88604 6.20344 5.83345 6.33594 5.83345C6.46844 5.83345 6.59552 5.88604 6.68927 5.97967L8.0026 7.29301L9.31594 5.97967C9.41072 5.89135 9.53608 5.84327 9.66562 5.84556C9.79515 5.84784 9.91874 5.90032 10.0104 5.99193C10.102 6.08354 10.1544 6.20713 10.1567 6.33666C10.159 6.46619 10.1109 6.59156 10.0226 6.68634L8.70927 7.99967L10.0226 9.31301C10.1109 9.40779 10.159 9.53315 10.1567 9.66269C10.1544 9.79222 10.102 9.91581 10.0104 10.0074C9.91874 10.099 9.79515 10.1515 9.66562 10.1538C9.53608 10.1561 9.41072 10.108 9.31594 10.0197L8.0026 8.70634L6.68927 10.0197C6.59449 10.108 6.46912 10.1561 6.33959 10.1538C6.21005 10.1515 6.08646 10.099 5.99486 10.0074C5.90325 9.91581 5.85077 9.79222 5.84849 9.66269C5.8462 9.53315 5.89428 9.40779 5.9826 9.31301L7.29594 7.99967L5.9826 6.68634C5.88897 6.59259 5.83638 6.46551 5.83638 6.33301C5.83638 6.20051 5.88897 6.07342 5.9826 5.97967Z"
				fill="#475163"
			/>
		</svg>
	)
}

export default SubjectSearchIcon
